import { IdMeSuccessResponse } from '../services/discountService/DiscountService'
interface Message {
  response: IdMeSuccessResponse | null | undefined
  status: string
  windowId: string
  source: string
}

export const postMessageToParent = (message: Message) => {
  window.opener?.postMessage(message, window.location.origin)
}

export const closeWindow = () => {
  window.close()
}

export const isBrowser = () => {
  return typeof window !== 'undefined'
}
